module.exports = __webpack_public_path__ + "search-icon.bbb0d92ecc818227a22b.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/search-icon.svg
// module id = ../../../../../src/img/icon/search-icon.svg
// module chunks = styles